export enum CiteEmbedTabEnum {
  CITE = "cite",
  EMBED = "embed",
}

export interface ICiteEmbedEvent {
  title: string;
  slug: string;
}

export interface ICitationLeader {
  outcome: string;
  chance: number;
  platformCount: number;
  updatedAt: string;
}
